@if (userInfo?.Name && userInfo?.Email) {
  <div class="overlay-popup">
    @if (userInfo?.ForLockedOverlay) {
      <div class="headerMessage" >
        <span class="icon-ic-warning warning-icon-top color-warning p-l-xs cursor pos-relative">
          </span> <span>{{headerMessage}} </span>
        </div>
      }
      @if (userInfo?.ForLockedOverlay) {
        <div class="p-xs">File under upload by</div>
      }
      <div class="data-item" >
        <div class="name-container" [ngClass]="{'nameColor':userInfo?.ForLockedOverlay}">
          @if (userInfo?.ForLockedOverlay) {
            <span class="name">{{userInfo.PUID}} - </span>
          }
          <span class="name">{{ userInfo.Name }}</span>
          @if (userInfo?.IsActiveUser === false) {
            <span class="status">Inactive</span>
          }
        </div>
      </div>
      <div class="data-item icon-color">
        {{ userInfo.Email }}
        <div>
          <button
            mat-icon-button
            [attr.id]="buildUserInfoOverlayId('btn-copy-email')"
            (click)="copyToClipBoard(userInfo?.Email)">
            <span
              class="icon-ic-copy"
              [attr.id]="buildUserInfoOverlayId('ico-copy-email')"
              matTooltipClass="tooltip-style"
              matTooltipPosition="above"
              matTooltip="Copy"
            ></span>
          </button>
        </div>
      </div>
    </div>
  }
